<template>
    <div class="recipe-page">
        <navigation class="recipe-page__nav" />
        <mix-header class="recipe-page__header" />
        <recipe :recipe="getProductFromURL"/>
    </div>
</template>

<script>
import mixologyData from "./../../static/libs/mixology";
import recipeJson from "./../../static/libs/recipes.json";
import Navigation from '@/components/Navigation';
import MixHeader from '@/components/mixology/MixHeader';
import Recipe from "@/components/mixology/recipe";


export default {

    name: "recipe-page",
    components: {
        Navigation,
        MixHeader,
        Recipe
    },
    props: {
        recipe: {
            type: Array
        }
    },
    data() {
        return {
            mixologyData,
            recipeJson,
        };
    },

    methods: {

    },
    
    computed: {
        getProductFromURL: function () {
            //need to validate if recipe exists, if not go somewhere???
            var friendlyNameUrl  = this.$route.query.name
            return this.recipeJson.recipes.find(m => m.friendlyname.includes(friendlyNameUrl))
        }
    },

    created() {
        // return console.log(this.recipeJson.recipes.filter("lime"))
    },
    
};
</script>

<style lang="scss" scoped>

    .recipe-page {
        &__nav{
            @media(min-width: 768px){
                position: relative;
                background-color: #fff ;
                top: 0;
                width:100vw;
                z-index: 999;
            };
        }

        &__nav {
            position: relative;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/RecipesPage.vue